export default "__VITE_ASSET__CmnxZsu2__"